var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailRequested = function SvgEmailRequested(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 41.5-4 3M8 45c-.333.167-1.3.2-2.5-1S4 41.5 4 41M3 38v-4",
    stroke: "#fff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40 32.5-37-14L49 2l-9 30.5Z",
    fill: "#FFC83D",
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33 15.5-11.5 9 4.262 1.5L33 15.5Z",
    fill: "#FFA800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25 48 3",
    stroke: "#fff",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37V25l8 3-8 9Z",
    fill: "#FFC83D",
    stroke: "#fff",
    strokeWidth: 2
  })));
};
export { SvgEmailRequested as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNDciIHZpZXdCb3g9IjAgMCA1MSA0NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNDEuNUwxMS41IDQ0LjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNOCA0NUM3LjY2NjY3IDQ1LjE2NjcgNi43IDQ1LjIgNS41IDQ0QzQuMyA0Mi44IDQgNDEuNSA0IDQxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTMgMzhWMzQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNDAgMzIuNUwzIDE4LjVMNDkgMkw0MCAzMi41WiIgZmlsbD0iI0ZGQzgzRCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zMyAxNS41TDIxLjUgMjQuNUwyNS43NjE5IDI2TDMzIDE1LjVaIiBmaWxsPSIjRkZBODAwIi8+CjxwYXRoIGQ9Ik0xOSAyNUw0OCAzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE5IDM3VjI1TDI3IDI4TDE5IDM3WiIgZmlsbD0iI0ZGQzgzRCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";